import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { tokens } from "../../../../../../theme";

import Text from "../../../../../../components/theme/text/Text";

import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import MpAddWebshop from "../../../../../../components/global/ModalsProgression/MpAddWebshop/MpAddWebshop";
import MpAmazonOAuthFinalize from "../../../../../../components/global/ModalsProgression/MpAmazonOAuthFinalize/MpAmazonOAuthFinalize";
import MpTikTokOAuthFinalize from "../../../../../../components/global/ModalsProgression/MpTikTokOAuthFinalize/MpTikTokOAuthFinalize";
import { config as apiUrlConfig } from "../../../../../../newapi/apiUrlConfig";
import { useExchangeTikTokCodeMutation } from "../../../../../../newapi/oauth/oauthSlice";
import { RelationWebshopIntegrationCard } from "../../../../../../components/global/cards/other/WebshopIntegrationCard";
import ButtonGroup from "../../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../../components/theme/datagrid2/ShDataGrid2";
import ShLabel from "../../../../../../components/theme/label/ShLabel";
import SidepanelLoader from "../../../../../../components/theme/sidepanel2/SidepanelLoader";
import ShLabelSkeleton from "../../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../../components/theme/skeleton/ShTextSkeleton";
import { selectUserPermission } from "../../../../../../newapi/user/authentication/authSlice";
import { useGetWebshopCredentialsQuery, useCreateWebshopFromInstallationMutation } from "../../../../../../newapi/webshop/webshopSlice";
import { getWebshopLogo } from "../../../../../../utils/logomapper";
import { UserPrivileges } from "../../../../../../utils/permissions";
import { showToastMessageUpdateRequest, showToastMessageRequestError } from "../../../../../../utils/toasts";
import SpEtailizeWebshopDetails from "../../../../../../components/global/Sidepanels/SpEtailizeWebshopDetails/SpEtailizeWebshopDetails";
import { WEBSHOP_FILTER_KEYS } from "../../../../../../components/global/DataGrid/Filter";

const SpWebshopCredentialsDetails = SidepanelLoader(() => import("../../../../../../components/global/Sidepanels/SpWebshopCredentialsDetails/SpWebshopCredentialsDetails"));

const GridActions = (props, i18n) => {
    const theme = useTheme();
    useEffect(() => {},[props.open]);
    const {t} = useTranslation();

    return (      
        <ButtonGroup version={2}>
            {props.hasCreatePermission && (
            <Shbutton 
                onClick={() => props.handleOpen(true)}
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                variant="contained" 
                endIcon={<AddIcon/>}>{t("new_saleschannel")}</Shbutton>
            )}
        </ButtonGroup>
    );
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [WEBSHOP_FILTER_KEYS.RELATION,WEBSHOP_FILTER_KEYS.WAREHOUSE],
};

const All = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended,setIsExtended] = useState(false);
    const [isExtendedEtailize,setIsExtendedEtailize] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [config, setConfig] = useState({"all_credentials": true, "integrator": 0, "deactivated": false});
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.WEBSHOPCREDENTIALS_MANAGE])
    );
    
    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
      };

    const [searchParams] = useSearchParams();
    const [installationStarted, setInstallationStarted] = useState(false);
    const [createWebshopFromInstallation] = useCreateWebshopFromInstallationMutation();

    const [webshopCredentialsId, setWebshopCredentialsId] = useState();
    const webshopCredentialsIdRef = useRef(webshopCredentialsId);

    // Handle bol.com OAuth installation flow
    useEffect(() => {
        const handleBolInstallation = async () => {
            if (installationStarted) return;

            const type = searchParams.get('type');
            const state = searchParams.get('state');
            const code = searchParams.get('code');

            if (type !== 'bol' || !state) return;

            setInstallationStarted(true);

            const installationData = {
                shop: decodeURIComponent(state),
                code: code ? decodeURIComponent(code) : undefined,
                type: type
            };

            try {
                const result = await createWebshopFromInstallation(installationData).unwrap();
                showToastMessageUpdateRequest(t, result);

                if (result.data && result.data.id) {
                    const newWebshopCredentialsId = parseInt(result.data.id);
                    if (!spLoading) {
                        setSpLoading(true);
                    }
                    setWebshopCredentialsId(newWebshopCredentialsId);
                    webshopCredentialsIdRef.current = newWebshopCredentialsId;
                    setIsExtended(true);
                }
            } catch (error) {
                if (error?.status !== 400 && error?.status !== 404) {
                    showToastMessageRequestError(t('installation_failed'), t, error);
                }
            }
        };

        handleBolInstallation();
    }, [searchParams]);

    const [amazonFinalize, setAmazonFinalize] = useState(null);

    useEffect(() => {
        const resumeId = searchParams.get('amazon_oauth_resume');
        const errorCode = searchParams.get('amazon_oauth_error');

        if (errorCode) {
            showToastMessageRequestError(t('amazon_connection_failed'), t, { status: errorCode });
            return;
        }

        if (resumeId) {
            fetch(`${apiUrlConfig.url.API_BACKEND_URL}oauth/amazon/resume-session?id=${encodeURIComponent(resumeId)}`, {
                credentials: 'include',
            })
                .then(r => r.ok ? r.json() : Promise.reject(r))
                .then(({ refresh_token, selling_partner_id }) => {
                    setAmazonFinalize({
                        refreshToken: refresh_token,
                        sellingPartnerId: selling_partner_id,
                    });
                })
                .catch(() => {
                    showToastMessageRequestError(
                        t('amazon_connection_failed'), t, { status: 'resume_failed' },
                    );
                });
            return;
        }

        const callbackUri = localStorage.getItem('amazon_installation_callback_uri');
        if (!callbackUri) return;

        const amazonState = localStorage.getItem('amazon_installation_state');
        const sellingPartnerId = localStorage.getItem('amazon_installation_selling_partner_id');
        const expires = new Date(localStorage.getItem('amazon_installation_expires'));

        localStorage.removeItem('amazon_installation_callback_uri');
        localStorage.removeItem('amazon_installation_state');
        localStorage.removeItem('amazon_installation_selling_partner_id');
        localStorage.removeItem('amazon_installation_expires');

        if (new Date() > expires) return;

        const frontendState = (window.crypto && window.crypto.randomUUID)
            ? window.crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

        const params = new URLSearchParams({
            amazon_callback_uri: callbackUri,
            amazon_state: amazonState,
            selling_partner_id: sellingPartnerId,
            state: frontendState,
        });
        window.location.href = `${apiUrlConfig.url.API_BACKEND_URL}oauth/amazon/login-resume?${params.toString()}`;
    }, [searchParams]);

    const [tiktokFinalize, setTiktokFinalize] = useState(null);
    const tiktokExchangeStartedRef = useRef(false);
    const [exchangeTikTokCode] = useExchangeTikTokCodeMutation();

    useEffect(() => {
        const type = searchParams.get('type');
        const code = searchParams.get('code');

        if (type !== 'tiktokshop' || !code) return;
        if (tiktokExchangeStartedRef.current) return;
        tiktokExchangeStartedRef.current = true;

        exchangeTikTokCode({ code: decodeURIComponent(code) }).unwrap()
            .then((payload) => {
                setTiktokFinalize(payload);
            })
            .catch(() => {
                showToastMessageRequestError(t('tiktok_connection_failed'), t, { status: 'exchange_failed' });
            });
    }, [searchParams]);

    const getWebshopCredentialDetails = (params) => {
        if (!params) return;
    
        const newwebshopCredentialsId = parseInt(params.row.id);
        // Only update state if the webshopCredentialsId has actually changed
        if (webshopCredentialsIdRef.current !== newwebshopCredentialsId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setWebshopCredentialsId(newwebshopCredentialsId);
            webshopCredentialsIdRef.current = newwebshopCredentialsId; // Update the ref to the new value
        }
        if(params.row.integrator){
            console.log("showing integrator");
            setIsExtendedEtailize(true)
        } else {
            console.log("showing normal");
            setIsExtended(true);
        }
        
    };
    
    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions:gridOptions,
            mobileActions:<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);
    const columns = [
        {field: "description", headerName: t("channel") , flex:2, cellClassName: "webshop", renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            let name = cellValues.row.webshop_type;
            if(cellValues.row.webshop_type === "etailize") {
                name = cellValues.row.credentials || cellValues.row.webshop_type;
            }
            const webshopLogo = getWebshopLogo(cellValues.row.webshop_type,{theme,colors},name);
            // const webshopLogo = getWebshopLogo(cellValues.row.webshop_type, cellValues.row.description);
            return (
                <>
                <Box sx={{ paddingRight: '10px' }}>
                    {webshopLogo}
                </Box>
                <Text semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{cellValues.value}</Text>
                </>
            )
        }},
        ...isFulfilment ? [{field: "relation", headerName: t("relation") , filter: WEBSHOP_FILTER_KEYS.RELATION, flex:2, cellClassName: "relation", renderCell : (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <Text>{cellValues.value?.name}</Text>
            )
        }}] : [],
        {field: "warehouse", headerName: t("warehouse") , flex:2, cellClassName: "warehouse", filter: WEBSHOP_FILTER_KEYS.WAREHOUSE, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text  >{cellValues.value?.name}</Text>
            )
        }},
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const labelColor = params.row.state === "active" ? "green" : theme.palette.mode === "dark" ? "greyLight" : "grey";
              
                return (
                    <ShLabel size={32} palette="normal" variant={labelColor}>
                      {t(params.row.state)}
                    </ShLabel>
                  );
              }
                
        },
        {field: "createdAt", headerName: t("created_at") , flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            let date = new Date(cellValues.row.createdAt).toLocaleDateString(i18n.language);

            return (
                <Text>{date}</Text>
            )
        }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <RelationWebshopIntegrationCard 
                        skeleton={cellValues.row.skeleton ?? false} 
                        {...cellValues.row}
                        onClick={() => getWebshopCredentialDetails(cellValues)}
                    />
                )
            }
        }
    ];

    return (
        <Box
            sx={{
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
            
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetWebshopCredentialsQuery}
                config={config}
                gridActions={<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>} 
                title={t("saleschannels")}
                gridOptions={gridOptions} 
                sortModel={{field: columns[0].field,type:"ASC"}}
                columns={columns}
                onRowClick={getWebshopCredentialDetails}>
            </ShDataGrid2>

            <MpAddWebshop onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose}/>
            {amazonFinalize && (
                <MpAmazonOAuthFinalize
                    open={!!amazonFinalize}
                    handleClose={() => setAmazonFinalize(null)}
                    refreshToken={amazonFinalize.refreshToken}
                    sellingPartnerId={amazonFinalize.sellingPartnerId}
                />
            )}
            {tiktokFinalize && (
                <MpTikTokOAuthFinalize
                    open={!!tiktokFinalize}
                    handleClose={() => setTiktokFinalize(null)}
                    payload={tiktokFinalize}
                />
            )}

            {spLoading &&
                <SpWebshopCredentialsDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    webshopCredentialsId={webshopCredentialsId}
                    // data={credentialData}     
                /> 
            }
            {spLoading && 
               <SpEtailizeWebshopDetails
                    isExtended={isExtendedEtailize}
                    setIsExtended={setIsExtendedEtailize}
                    etailizeWebshopId={webshopCredentialsId}
                    // data={credentialData} 
                /> 
            }
            
        </Box>
    )
};

export default All;